<div class="control-item-component">
  <div p-dialog-content>
    <div class="form-grid grid">
      <div class="field col">
        <div class="flex gap-5 form-row">
          <div style="flex: 0 0 120px;">
            <label class="block font-bold mb-2" for="dateRaised">Date Raised</label>
            <p-datepicker inputId="dateRaised"
                          [(ngModel)]="risk.dateRaised"
                          showIcon="true"
                          dataType="string"
                          dateFormat="mm/dd/yy"
                          class="w-full dateraised"></p-datepicker>
          </div>

          <div style="flex: 1 1 0%; min-width: 240px;">
            <label class="block font-bold mb-2" for="name">Name</label>
            <input inputId="name"
                   type="text"
                   pInputText
                   [(ngModel)]="risk.name"
                   class="w-full p-inputtext" />
          </div>

          <div style="flex: 0 0 160px;">
            <label class="block font-bold mb-2" for="type">Type</label>
            <p-multi-select inputId="type"
                            [(ngModel)]="risk.typeList"
                            [options]="typeOptions"
                            style="width:100%;"></p-multi-select>
          </div>
        </div>


      </div>


      <div class="field col">
        <label class="block font-bold mb-3">Scope</label>
        <div class="flex gap-5">

          <div style="flex: 0 0 160px;">
            <label class="block font-bold mb-2" for="enterpriseWide">Enterprise-Wide</label>
            <p-checkbox inputId="enterpriseWide"
                        [(ngModel)]="risk.enterpriseWide"
                        binary="true">
            </p-checkbox>
          </div>

          <div style="flex: 0 0 260px;">
            <label class="block font-bold mb-2" for="businessUnit">Business Unit</label>
            <p-select inputId="businessUnit"
                      [(ngModel)]="risk.businessUnit"
                      placeholder="Select Business Unit"
                      [options]="businessUnitOptions"
                      style="width:100%;">
            </p-select>
          </div>

        </div>
      </div>


      <div class="field col">
        <label class="block font-bold mb-3">Rating</label>
        <div class="flex gap-5">

          <div style="flex: 0 0 120px;">
            <label class="block font-bold mb-2" for="score">Score</label>
            <p-select inputId="score"
                      [(ngModel)]="risk.score"
                      [options]="scoreOptions"
                      style="width:100%;">
            </p-select>
          </div>

          <div style="flex: 0 0 160px;">
            <label class="block font-bold mb-2" for="likelihood">Likelihood</label>
            <p-select inputId="likelihood"
                      [(ngModel)]="risk.likelihood"
                      [options]="options"
                      style="width:100%;">
            </p-select>
          </div>

          <div style="flex: 0 0 160px;">
            <label class="block font-bold mb-2" for="severity">Severity</label>
            <p-select inputId="severity"
                      [(ngModel)]="risk.severity"
                      [options]="options"
                      style="width:100%;">
            </p-select>
          </div>

          <div style="flex: 0 0 140px;">
            <label class="block font-bold mb-2" for="riskValue">Risk</label>
            <p-select inputId="riskValue"
                      [(ngModel)]="risk.riskValue"
                      [options]="options"
                      style="width:100%;">
            </p-select>
          </div>

        </div>
      </div>

      <div class="field col">
        <label class="block font-bold mb-3">Ownership</label>
        <div class="flex gap-5">
          <div>
            <label class="block font-bold mb-2" for="finalDisposition">Disposition</label>
            <p-select inputId="finalDisposition"
                      [(ngModel)]="risk.finalDisposition"
                      [options]="finalDispositionOptions"></p-select>
          </div>

          <div>
            <label class="block font-bold mb-2" for="owner">Owner</label>
            <input inputId="owner"
                   type="text"
                   pInputText
                   [(ngModel)]="risk.owner"
                   class="w-full p-inputtext" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-grid grid">
      <div class="field col">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Risk Description</label>
          <p-button
            class="small-edit-btn"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.riskDescription = !visibility.riskDescription"
          >
            <ng-template pTemplate="icon">
              <span class="pi pi-pencil" style="font-size: 1rem"></span>
            </ng-template>
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.riskDescription"
          [innerHTML]="addToken(risk.riskDescription) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.riskDescription"
          type="text"
          name="references"
          [(ngModel)]="risk.riskDescription"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>
    <div class="form-grid grid">
      <div class="field col">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Impact</label>
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.impact = !visibility.impact"
          >
            <ng-template pTemplate="icon">
              <span
                class="pi pi-pencil"
                style="font-size: 1rem"
              ></span></ng-template
            >
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.impact"
          [innerHTML]="addToken(risk.impact) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.impact"
          type="text"
          name="references"
          [(ngModel)]="risk.impact"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>

    <div class="form-grid grid">
      <div class="field col">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Mitigation</label>
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.mitigation = !visibility.mitigation"
          >
            <ng-template pTemplate="icon">
              <span
                class="pi pi-pencil"
                style="font-size: 1rem"
              ></span></ng-template
            >
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.mitigation"
          [innerHTML]="addToken(risk.mitigation) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.mitigation"
          type="text"
          name="references"
          [(ngModel)]="risk.mitigation"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>
    <div class="form-grid grid">
      <div class="field col">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Contingency</label>
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.contingency = !visibility.contingency"
          >
            <ng-template pTemplate="icon">
              <span
                class="pi pi-pencil"
                style="font-size: 1rem"
              ></span></ng-template
            >
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.contingency"
          [innerHTML]="addToken(risk.contingency) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.contingency"
          type="text"
          name="references"
          [(ngModel)]="risk.contingency"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>
    <div class="form-grid grid">
      <div class="field col-4">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Status</label>
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.status = !visibility.status"
          >
            <ng-template pTemplate="icon">
              <span
                class="pi pi-pencil"
                style="font-size: 1rem"
              ></span></ng-template
            >
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.status"
          [innerHTML]="addToken(risk.status) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.status"
          type="text"
          name="references"
          [(ngModel)]="risk.status"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
      <div class="field col-8">
        <div class="flex align-content-center align-items-center gap-2">
          <label class="font-bold align-self-end">Progress</label>
          <p-button
            [rounded]="true"
            [text]="true"
            severity="secondary"
            (click)="visibility.progress = !visibility.progress"
          >
            <ng-template pTemplate="icon">
              <span
                class="pi pi-pencil"
                style="font-size: 1rem"
              ></span></ng-template
            >
          </p-button>
        </div>
        <div
          class="ql-editor"
          *ngIf="!visibility.progress"
          [innerHTML]="addToken(risk.progress) | sanitizeHtml"
        ></div>
        <p-editor
          *ngIf="visibility.progress"
          type="text"
          name="references"
          [(ngModel)]="risk.progress"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-size">
                <option value="huge">Heading</option>
                <option value="large">Subheading</option>
                <option selected></option>
                <option value="small">Small</option>
              </select>
              <select class="ql-font">
                <option selected="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
              <select class="ql-background">
                <option selected="selected"></option>
                <option value="#e60000"></option>
                <option value="#ff9900"></option>
                <option value="#ffff00"></option>
                <option value="#008a00"></option>
                <option value="#0066cc"></option>
                <option value="#9933ff"></option>
                <option value="#ffffff"></option>
                <option value="#facccc"></option>
                <option value="#ffebcc"></option>
                <option value="#ffffcc"></option>
                <option value="#cce8cc"></option>
                <option value="#cce0f5"></option>
                <option value="#ebd6ff"></option>
                <option value="#bbbbbb"></option>
                <option value="#f06666"></option>
                <option value="#ffc266"></option>
                <option value="#ffff66"></option>
                <option value="#66b966"></option>
                <option value="#66a3e0"></option>
                <option value="#c285ff"></option>
                <option value="#888888"></option>
                <option value="#a10000"></option>
                <option value="#b26b00"></option>
                <option value="#b2b200"></option>
                <option value="#006100"></option>
                <option value="#0047b2"></option>
                <option value="#6b24b2"></option>
                <option value="#444444"></option>
                <option value="#5c0000"></option>
                <option value="#663d00"></option>
                <option value="#666600"></option>
                <option value="#003700"></option>
                <option value="#002966"></option>
                <option value="#3d1466"></option>
              </select>
              <span class="ql-format-separator"></span>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Left</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button
                aria-label="Document"
                class="custom-button"
                style="font-size: 1.3em; margin-top: -3px"
                #el
                (click)="selectDocument(el)"
              >
                D
              </button>
              <button aria-label="Image" class="ql-image"></button>
              <button aria-label="Code block" class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Clean" class="ql-clean"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>

    <div class="form-grid grid">
      <div class="field col">
        <p-table
          [value]="risk.relatedControlsList"
          #controls
          styleClass="risk-table-striped"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center">
              <label class="block font-bold">Related Controls</label>
              <p-button
                [text]="true"
                icon="pi pi-plus"
                (click)="addControl()"
                class="ml-auto"
              ></p-button>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="font-bold white-space-nowrap">Project name</th>
              <th class="font-bold white-space-nowrap">Compliance Area</th>
              <th style="width: 3rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-control>
            <tr>
              <td>
                {{ control.projectName }}
              </td>
              <td>
                {{ control.complianceAreaControlId }}
              </td>
              <td>
                <div style="display: flex;">
                  <p-button
                    [text]="true"
                    icon="pi pi-file-export"
                    severity="danger"
                    (click)="makePoam(control.projectControlItemId)"
                  ></p-button>
                  <p-button
                    [text]="true"
                    icon="pi pi-trash"
                    severity="danger"
                    (click)="removeControl(control.id)"
                  ></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div class="p-dialog-footer flex gap-2 justify-content-end">
  <p-button label="Save" outlined="true" (click)="onSave()"></p-button>
  <p-button
    label="Cancel"
    outlined="true"
    severity="secondary"
    (click)="onClose()"
  ></p-button>
</div>
